module.exports = __webpack_public_path__ + "img/CONNECTING CONVEYOR.38d5d3de.jpg";